import { render } from "./BaseButtonDisabled.vue?vue&type=template&id=1c84adc7"
const script = {}

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__